import { PayloadAction } from '@reduxjs/toolkit';
import { sortByName } from 'common/utils/sorting';

import { IState } from '../types';
import { IRoadsideService } from 'dataSources/Typicode/common/types';

const roadsideServiceOrder = [1, 13, 3, 11, 12, 2, 9, 5];

interface IAction
  extends Pick<
    IState,
    | 'countries'
    | 'roadsideService'
    | 'stationCategories'
    | 'serviceFormats'
    | 'additionalParams'
    | 'additionalServices'
    | 'services'
    | 'countriesBrands'
    | 'paymentTypes'
  > {}

const initDirectories = (state: IState, action: PayloadAction<IAction>) => {
  const {
    countries,
    roadsideService,
    stationCategories,
    serviceFormats,
    additionalParams,
    services,
    additionalServices,
    countriesBrands,
    paymentTypes,
  } = action.payload;
  const roadsideServiceMap = new Map<number, IRoadsideService>(
    roadsideService.map((service) => [Number(service.code), service]),
  );

  state.initRoadsideService = roadsideServiceOrder
    .map((key) => roadsideServiceMap.get(key))
    .filter((service): service is IRoadsideService => !!service);
  state.countries = countries.sort(sortByName);
  state.stationCategories = stationCategories.sort(sortByName);
  state.serviceFormats = serviceFormats.sort(sortByName);
  state.additionalParams = additionalParams.sort(sortByName);
  state.additionalServices = additionalServices.sort(sortByName);
  state.countriesBrands = countriesBrands;
  state.services = services;
  state.paymentTypes = paymentTypes;
};

export default initDirectories;
